import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import alertify from 'alertifyjs/build/alertify.min.js';
import 'alertifyjs/build/css/alertify.min.css';
import 'alertifyjs/build/css/themes/default.min.css';
import VeeValidate from 'vee-validate';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import VueGtag from "vue-gtag";
import QrcodeVue from 'qrcode.vue';
import { rememberEntryFlags } from './kiosk';

rememberEntryFlags();

window.alertify = alertify;

// Configure alertify
alertify.set('notifier', 'delay', 5);
alertify.set('notifier', 'position', 'top-center');
alertify.set('prompt', 'reverseButtons', true);
alertify.set('prompt', 'transition', 'fade');
alertify.set('confirm', 'transition', 'fade');

Vue.config.productionTip = false;

// Register vee-validate
Vue.use(VeeValidate, {
  events: 'blur',
  classes: true
});

// Register QRCode component globally 👇
Vue.component('QrcodeVue', QrcodeVue);

Vue.mixin({
  methods: {
    focusOut(event) {
      event.target.blur()
    }
  }
});

// Configure Sentry
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://' + process.env.VUE_APP_SENTRY_KEY + '@sentry.hellofirstview.com/' + process.env.VUE_APP_SENTRY_PROJECT,
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
  });
}

// Configure Google Analytics
Vue.use(VueGtag, {
  config: { id: "UA-156971159-1" }
});

// Mount app
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
